export default __webpack_public_path__ + "static/media/ic-5-grab-voucher.54e77a9a.svg";